<script>
  import {getContext} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {sd} from '@/da';
  import {fixLink$, isLogin$} from '@/store';
  import {getP2PTradeDefaultUrlLocal} from '@/modules/buy-crypto/fiat/components/util';
  import MenuItemView from '../components/MenuItemView.svelte';
  import lang from '../../Header.lang';

  const LG = getContext('LG');

  function handleBuyClickFuc(item) {
    return function () {
      sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_buy_crypto_' + item});
    };
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    padding: 16px;
    width: 328px;
    background: rgba(26, 29, 31, 0.96);
    cursor: default;
    overflow: hidden;
    backdrop-filter: blur(10px);
  }
</style>

<div class="wrap df fdc T2">
  <MenuItemView
    theme="dark"
    iconAlt="p2p marketplace"
    iconUrl="https://img.phemex.com/v1/7c28167c-ab17-404f-9732-3f12a7ea0a8c/property-1-one-click-buy-property-2-sell.svg"
    link={$fixLink$(PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname)}
    title={LG(lang.OneClickBuyAndSell)}
    subTitle={LG(lang.OneClickBuyAndSellSubTitle)}
    on:click={handleBuyClickFuc('one_click_buy_sell')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    iconAlt="p2p marketplace"
    iconUrl="https://img.phemex.com/v1/d014e58e-adea-4e50-82b6-26f9654633f6/fiat-deposit-dark.png"
    link={$fixLink$(PATHS.FIAT_DEPOSIT.pathname)}
    title={LG(lang.FiatDeposit)}
    titleIcon="https://img.phemex.com/v1/e7c869ca-5a66-44a4-8a8c-b24314d60617/fee.svg"
    titleIconAlt="zero-fee"
    subTitle={LG(lang.FiatDepositSubTitle)}
    on:click={handleBuyClickFuc('fiat_deposit')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    target="_self"
    iconAlt="credit debit card"
    iconUrl="https://img.phemex.com/v1/6f2e0cf2-6852-4c34-8d47-94ad5f77dd29/property-1-credit.svg"
    link={$fixLink$(PATHS.BUY_CRYPTO_CARD_PLACE_ORDER.pathname)}
    title={LG(lang.CreditDebitCards)}
    titleIcon="https://img.phemex.com/v1/58a1fac2-1c3a-4458-ad08-4f34a751aa00/fee-1.svg"
    titleIconAlt="lowest-fee"
    subTitle={LG(lang.CreditDebitCardsSubTitle)}
    on:click={handleBuyClickFuc('credit_debit_card')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    iconAlt="p2p marketplace"
    iconUrl="https://img.phemex.com/v1/24a153c4-0b24-4064-8b11-f5c32473d070/property-1-p2-p.svg"
    link={getP2PTradeDefaultUrlLocal($isLogin$, $fixLink$)}
    title={LG(lang.P2PTrading)}
    subTitle={LG(lang.P2PTradingSubtitle)}
    on:click={handleBuyClickFuc('p2p_trading')}
    noArrow
  />
</div>
